export default "/images/vendor/@coreui/icons/svg/flag/cif-jm.svg?e57c8ab82ecab432ed3dfe472cab4580";